import React, { ReactNode } from 'react';

interface Children {
  children: ReactNode;
}

const index = (props: Children) => {
  return (
    <div style={{ padding: window.innerWidth <= 426 ? '' : '45px 33px' }}>
      {props.children}
    </div>
  );
};

export default index;
